import { NgModule } from '@angular/core';
import {  NgbPaginationModule, NgbAlertModule, NgbDropdownModule, NgbDatepickerModule, 
    NgbModalModule, NgbCollapseModule, NgbTooltipModule, NgbTypeaheadModule, NgbTimepickerModule, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  exports: [
    NgbPaginationModule,
    NgbAlertModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbModalModule,
    NgbCollapseModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
    NgbPopoverModule,
  ]
})
export class BootstrapLibModule {}
